import '../index.scss';

import { forwardRef } from 'react';

import { RibbonButton, RibbonButtonProps } from './RibbonButton';

export type RibbonButtonLinkProps = RibbonButtonProps & {
  href: string;
  target?: string;
  rel?: string;
};

export const RibbonButtonLink = forwardRef<HTMLButtonElement, RibbonButtonLinkProps>(function RibbonButtonLink(
  { onClick, href, rel = 'noreferrer', target = '_blank', ...props },
  ref,
) {
  return (
    <RibbonButton
      ref={ref}
      {...props}
      onClick={() => {
        onClick?.();
        void window.open(href, target, rel);
      }}
    />
  );
});
